import React, { Dispatch, SetStateAction } from 'react';
import invariant from 'tiny-invariant';
import WizardContext from '../providers/WizardProvider/WizardContext';

const useSetSelfRating = (): Dispatch<SetStateAction<number | null>> => {
  const ctx = React.useContext(WizardContext);
  invariant(ctx, "Don't use 'useSetPromotions' outside of <WizardProvider>");
  return ctx.setSelfRating;
};

export default useSetSelfRating;
